import { Box, Button, Container, Grid, Typography, Card, CardContent } from '@mui/material';
import { Link } from 'react-router-dom';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import PeopleIcon from '@mui/icons-material/People';

const features = [
  {
    icon: <AutoAwesomeIcon sx={{ fontSize: 40, color: 'primary.main' }} />,
    title: 'AI フル活用',
    desc: '最新の生成AIを駆使したプロダクト開発・業務自動化を提供します。',
  },
  {
    icon: <RocketLaunchIcon sx={{ fontSize: 40, color: 'secondary.main' }} />,
    title: 'SaaS 開発',
    desc: 'スケールするSaaSプロダクトを、設計から運用まで一気通貫でサポートします。',
  },
  {
    icon: <PeopleIcon sx={{ fontSize: 40, color: 'primary.main' }} />,
    title: 'AI 導入コンサル',
    desc: '現場の課題に合ったAI活用戦略を立案し、実装まで伴走します。',
  },
];

export default function Home() {
  return (
    <Box>
      {/* Hero */}
      <Box
        sx={{
          minHeight: '90vh',
          display: 'flex',
          alignItems: 'center',
          background: 'radial-gradient(ellipse at 20% 50%, rgba(0,229,255,0.08) 0%, transparent 60%), radial-gradient(ellipse at 80% 20%, rgba(124,77,255,0.08) 0%, transparent 60%)',
        }}
      >
        <Container maxWidth="lg">
          <Box sx={{ maxWidth: 720 }}>
            <Typography
              variant="overline"
              sx={{ color: 'primary.main', letterSpacing: 4, fontWeight: 700 }}
            >
              takoshiLabo株式会社
            </Typography>
            <Typography
              variant="h1"
              sx={{ fontSize: { xs: '2.5rem', md: '4rem' }, mt: 2, mb: 3, lineHeight: 1.1 }}
            >
              AIで、現場を<br />
              <Box component="span" sx={{ color: 'primary.main' }}>もっと速く。</Box>
            </Typography>
            <Typography variant="h6" color="text.secondary" sx={{ mb: 5, lineHeight: 1.8, fontWeight: 400 }}>
              SaaS開発・AI活用・現場へのAI導入コンサルティング。<br />
              最新技術で、あなたのビジネスの可能性を広げます。
            </Typography>
            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
              <Button
                component={Link}
                to="/services"
                variant="contained"
                size="large"
                sx={{ px: 4, py: 1.5, fontWeight: 700 }}
              >
                サービスを見る
              </Button>
              <Button
                component={Link}
                to="/contact"
                variant="outlined"
                size="large"
                sx={{ px: 4, py: 1.5, fontWeight: 700 }}
              >
                お問い合わせ
              </Button>
            </Box>
          </Box>
        </Container>
      </Box>

      {/* Features */}
      <Box sx={{ py: 12, bgcolor: 'background.paper' }}>
        <Container maxWidth="lg">
          <Typography variant="h2" align="center" sx={{ mb: 8, fontSize: { xs: '2rem', md: '2.8rem' } }}>
            私たちができること
          </Typography>
          <Grid container spacing={4}>
            {features.map((f) => (
              <Grid item xs={12} md={4} key={f.title}>
                <Card
                  elevation={0}
                  sx={{
                    height: '100%',
                    p: 2,
                    border: '1px solid rgba(255,255,255,0.08)',
                    transition: 'border-color 0.3s',
                    '&:hover': { borderColor: 'primary.main' },
                  }}
                >
                  <CardContent>
                    <Box sx={{ mb: 2 }}>{f.icon}</Box>
                    <Typography variant="h5" sx={{ mb: 1.5, fontWeight: 700 }}>
                      {f.title}
                    </Typography>
                    <Typography color="text.secondary" sx={{ lineHeight: 1.8 }}>
                      {f.desc}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* CTA */}
      <Box
        sx={{
          py: 12,
          textAlign: 'center',
          background: 'radial-gradient(ellipse at center, rgba(0,229,255,0.05) 0%, transparent 70%)',
        }}
      >
        <Container maxWidth="sm">
          <Typography variant="h3" sx={{ mb: 3, fontSize: { xs: '1.8rem', md: '2.4rem' } }}>
            まずは、話しましょう。
          </Typography>
          <Typography color="text.secondary" sx={{ mb: 5, lineHeight: 1.8 }}>
            課題やアイデアをお気軽にご相談ください。
          </Typography>
          <Button
            component={Link}
            to="/contact"
            variant="contained"
            size="large"
            sx={{ px: 6, py: 2, fontWeight: 700, fontSize: '1rem' }}
          >
            無料相談する
          </Button>
        </Container>
      </Box>
    </Box>
  );
}
